module.exports = __webpack_public_path__ + "img/ffa.cdabe679.png";